import React, { useCallback, useContext, useMemo } from 'react';
import { SettingContext } from '../../context';
import { ProductCart } from './ProductCart';

export const ProductToCart = () => {
  const { infoSocket } = useContext(SettingContext);
  const { productsInCart, setQuantityProductsInCartShown } = infoSocket || {};

  const handledFinishAnimation = useCallback(() => {
    if (setQuantityProductsInCartShown) {
      setQuantityProductsInCartShown(prev => prev + 1);
    }
  }, [setQuantityProductsInCartShown]);

  return useMemo(
    () =>
      productsInCart &&
      productsInCart.map((product, index) => (
        <ProductCart
          key={index}
          image={product.productImageUrl}
          onFinishAnimation={handledFinishAnimation}
        />
      )),
    [handledFinishAnimation, productsInCart],
  );
};
